import { Config } from "../../env";
import AuthManager from "./Auth/AuthManager";
import EnvUtils from "./EnvUtils";

export function initialLetters(name: string) {
    name = name.replace(/\s(de|da|dos|das)\s/g, " ");
    const initials = name.match(/\b(\w)/gi);

    if (initials.length > 1) {
        return (initials[0] + initials[1]).toUpperCase();
    } else {
        return name.substr(0, 2);
    }
}

export function login() {
    return `${Config.API_ACCOUNTS_URL}/signin?response_type=token&client_id=${Config.CLIENT_ID
        }&redirect_uri=${EnvUtils.getRedirectUri()}&authorization_uri=${EnvUtils.getAuthorizationUri()}&language=pt-BR&portal_id=2`;
}
export function getUrlRedirectAlterAccountAuth() {
    return `${Config.API_ACCOUNTS_URL
        }/account/update/?response_type=token&authorization_uri=${EnvUtils.getAuthorizationUri()}?authorization_login=userdata&client_id=${Config.CLIENT_ID
        }&expires_in=${AuthManager.getAuthSession().expiresIn}&refresh_token=${AuthManager.getAuthSession().refreshToken
        }&token_type=bearer&access_token=${AuthManager.getAuthSession().accessToken
        } `;
}
export function getUrlRedirectMyAccountAuth() {
    return `${Config.API_MYACCOUNT_URL
        }/authorization/?response_type=token&authorization_uri=${EnvUtils.getAuthorizationUri()}?authorization_login=userdata&client_id=${Config.CLIENT_ID
        }&expires_in=${AuthManager.getAuthSession().expiresIn}&refresh_token=${AuthManager.getAuthSession().refreshToken
        }&token_type=bearer&access_token=${AuthManager.getAuthSession().accessToken
        }`;
}
export function getUrlRedirectFavoriteAuth() {
    return `${Config.API_MYACCOUNT_URL
        }/favorites/authorization/?response_type=token&authorization_uri=${EnvUtils.getAuthorizationUri()}?authorization_login=userdata&client_id=${Config.CLIENT_ID
        }&expires_in=${AuthManager.getAuthSession().expiresIn}&refresh_token=${AuthManager.getAuthSession().refreshToken
        }&token_type=bearer&access_token=${AuthManager.getAuthSession().accessToken
        }`;
}
export function getUrlRedirectMarketplaceAuth() {
    return `${Config.API_MARKETPLACE_URL
        }/authorization/?response_type=token&redirect_uri=${Config.API_MARKETPLACE_URL
        }&authorization_uri=${Config.API_MARKETPLACE_URL}/authorization&client_id=${Config.CLIENT_ID
        }&expires_in=${AuthManager.getAuthSession()?.expiresIn}&refresh_token=${AuthManager.getAuthSession()?.refreshToken
        }&token_type=bearer&access_token=${AuthManager.getAuthSession()?.accessToken
        }&authorization_login=userdata`;
}

export function register() {
    return `${Config.API_ACCOUNTS_URL
        }/signup?response_type=token&redirect_uri=${EnvUtils.getRedirectUri()}&authorization_uri=${EnvUtils.getAuthorizationUri()}?authorization_login=userdata&client_id=${Config.CLIENT_ID
        }&language=pt-BR&portal_id=2`;
}

function toBRL(value: number) {
    return Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
    }).format(value);
}
function toDecimal(value: number) {
    return Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
    }).format(value/100);
}

function toBRLWithSymbol(value: number) {
    return value.toLocaleString("pt-br", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
}

export function stringToSlug(str: string): string {
    str = str.replace(/^\s+|\s+$/g, ''); // trim
    str = str.toLowerCase();
   
    // remove accents, swap ñ for n, etc
    const from = 'ãàáäâèéëêìíïîòóöôùúüûñç·/_,:;';
    const to = 'aaaaaeeeeiiiioooouuuunc------';
    for (let i = 0, l = from.length; i < l; i++) {
      str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
    }
   
    str = str
      .replace(/[^a-z0-9 -]/g, '') // remove invalid chars
      .replace(/\s+/g, '-') // collapse whitespace and replace by -
      .replace(/-+/g, '-'); // collapse dashes
   
    return str;
  }


export function convertStateToInitials(state) {
    const formattedState = stringToSlug(state)
    switch (formattedState) {
        case "acre":
            return "AC";

        case "alagoas":
            return "AL";

        case "amazonas":
            return "AM";

        case "amapa":
            return "AP";

        case "bahia":
            return "BA";

        case "ceara":
            return "CE";

        case "distrito-federal":
            return "DF";

        case "espirito-santo":
            return "ES";

        case "goias":
            return "GO";

        case "maranhao":
            return "MA";

        case "mato-grosso-do-sul":
            return "MS";

        case "mato-grosso":
            return "MT";

        case "para":
            return "PA";

        case "paraiba":
            return "PB";

        case "pernambuco":
            return "PE";

        case "piaui":
            return "PI";

        case "parana":
            return "PR";

        case "rio-de-janeiro":
            return "RJ";

        case "rio-grande-do-norte":
            return "RN";

        case "rondonia":
            return "RO";

        case "roraima":
            return "RR";

        case "rio-grade-do-sul":
            return "RS";

        case "santa-catarina":
            return "SC";

        case "sergipe":
            return "SE";

        case "sao-paulo":
            return "SP";

        case "tocantins":
            return "TO";

        default:
            return "";

    }
}

const formatPrice = {
    toBRL,
    toBRLWithSymbol,
    toDecimal
};

export default formatPrice;
